module.exports = __webpack_public_path__ + "static/media/aviator_banner_mob.d4af3694.png";